const rpContractEditorVersionStatus = Object.freeze({
  Draft: 1,
  Published: 2,
  Inactive: 3,
});

export const rpContractEditorVersionStatusColor = Object.freeze({
  [rpContractEditorVersionStatus.Draft]: 'primary-16',
  [rpContractEditorVersionStatus.Published]: 'green-light-2',
  [rpContractEditorVersionStatus.Inactive]: 'secondary-2',
});

export default rpContractEditorVersionStatus;
